/**
 * Portfolio gallery
 *
 * - Initialize main gallery slider
 * - Add function to sync slider with thumbnails
 * - Add handler to thumbnails to navigate main gallery slider
 *
 */
;(function (pyatt, $, window, document, undefined) {

    pyatt.portfolioGallery = {

        $main : '',

        $thumbs : '',

        $modal : '',

        init : function() {

            //set jQuery objects here on init whenever that is
            //so that the vars are current to the DOM
            $main = $("#gallery-main");
            $thumbs = $("#gallery-thumbs");
            $modal = $("#galModalSlider");

            //console.log('galleryinit: ' + $main);

            // Adjust width to match browser width
            pyatt.util.adjustSliderWidth($main)
            //add handler to adjust with on resize
            $(window).on('resize', Foundation.utils.throttle( function() {
                pyatt.util.adjustSliderWidth($main);
            }, 300));

            //init main carousel slider
            $main.owlCarousel({
                singleItem: true,
                slideSpeed: 1000,
                navigation: true,
                navigationText: ["<span class='dashicons dashicons-arrow-left-alt2'></span>","<span class='dashicons dashicons-arrow-right-alt2'></span>"],
                pagination: false,
                afterAction: this.syncPosition,
                responsiveRefreshRate: 200,
                addClassActive: true,
                autoHeight: true,
                //autoWidth: true,
                //Lazy load
                lazyLoad: true,
                lazyFollow: true,
                //transitionStyle: "fade",
                //loop: false,
                lazyEffect: "fade",
            });

            //add click handler on thumbnails
            $thumbs.on("click", "li", this.thumbnailClickHandler);


            //init modal carousel slider
            $modal.owlCarousel({
                singleItem: true,
                slideSpeed: 1000,
                navigation: true,
                pagination: false,
                //afterAction: this.syncPosition,
                responsiveRefreshRate: 200,
                addClassActive: true,
                autoHeight: false,
                //Lazy load
                lazyLoad: true,
                lazyFollow: true,
                lazyEffect: "fade",
                rewindNav : false,
            });

            //add click handler on main image for modal
            $main.on("click", "a", this.modalClickHandler);

            // Set foundation modal links depending on browser width
            this.setModalLink();
            $(window).on('resize', Foundation.utils.throttle(this.setModalLink, 300));

        },


        /**
         * Sync slide position with thumbnail selection
         *
         * Adds 'synced' class to active slide
         *
         * @param el
         */
        syncPosition : function(el) {
            var current = this.currentItem;
            $thumbs
                .find("li")
                .removeClass("synced")
                .eq(current)
                .addClass("synced")
        },


        /**
         * Action when clicking on thumbnail
         *
         * @param e
         */
        thumbnailClickHandler : function(e) {
            console.log('thumbclick');
            e.preventDefault();
            var number = $thumbs.find('li').index(this);
            $main.trigger("owl.goTo", number);
        },


        /**
         * Action when clicking on main gallery image to open modal
         *
         * Move to related image
         *
         * @param e
         */
        modalClickHandler : function(e) {
            //console.log('modalclick');
            e.preventDefault();
            var number = ($(this).attr('data-slide-no')-1);
            $modal.trigger("owl.goTo", number);
        },


        /**
         * Adjust slider width to match browser width on mobile
         */
        adjustSliderWidth : function($container) {
            //console.log('adjustwidth');
            //only adjust on mobile view
            if ($(window).width() < 603) {
                var windowW = document.documentElement.clientWidth;
                $container.css('width', windowW);
            } else {
                $container.css('width', '');
            }
        },

        /**
         * Add foundation data-reveal-id attr for desktop widths
         * Pull from data-reveal-holding attr for data
         *
         */
        setModalLink : function() {
            var $modal_links = $main.find('a');

            // If mobile remove modal id
            if ($(window).width() < 583) {
                $modal_links.removeAttr('data-reveal-id');
                // If desktop add modal id
            } else {
                $modal_links.each( function(index) {
                    $(this).attr('data-reveal-id', 'galModal');
                });
            }
        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
